import { render, staticRenderFns } from "./DocRedemptionLetter.vue?vue&type=template&id=94dfc8fe"
import script from "./DocRedemptionLetter.vue?vue&type=script&lang=js"
export * from "./DocRedemptionLetter.vue?vue&type=script&lang=js"
import style0 from "./DocRedemptionLetter.vue?vue&type=style&index=0&id=94dfc8fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports